import { post } from "../../service/api";

const ImpersonateMerchant = async (merchantId) => {
  try {
    const response = await post(`/admin/impersonate/${merchantId}`);
    return response;
  } catch (error) {
    console.error("Error impersonating merchant:", error);
    throw error;
  }
};

export default ImpersonateMerchant;
